import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import SendIcon from "@mui/icons-material/Send";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  Alert,
  Badge,
  Box,
  Button,
  Card,
  DialogContent,
  Fab,
  FormControlLabel,
  Grid,
  Hidden,
  IconButton,
  MenuItem,
  Switch as RB,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import CardContent from "@mui/material/CardContent";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Zoom from "@mui/material/Zoom";
import axios from "axios";
import moment from "moment";
import "moment/locale/de";
import PropTypes from "prop-types";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import "react-big-calendar/lib/sass/styles.scss";
import { useTranslation } from "react-i18next";
import { Route, Routes, useNavigate, useSearchParams } from "react-router-dom";
import { Bar, BarChart, Cell as ChartCell, Line, LineChart, Pie, PieChart, XAxis, YAxis } from "recharts";
import { API_BASE_URL } from "../../constants/apiConstants";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import { DateToJulian, JulianToDate } from "../../functions/dates";
import { pad } from "../../functions/default";
import { Fehlzeitenkalender } from "../Kalender/Fehlzeitenkalender";
import { DateTextField, FullPageSpinner, getMonthName } from "../lib";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { NextMonthButton, NextYearButton, PreviousMonthButton, PreviousYearButton } from "../NavigationButtons/NavigationButtons";
import Layout from "../shared/components/LayoutComponent";
import MessageBox from "../shared/components/MessageBox";
import Page from "../shared/components/PageComponent";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import openFile from "../shared/functions/download";

function Absence(props) {
  const { t } = useTranslation();
  const { client, accessToken, updateTitle } = props;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [salden, setSalden] = useState([]);
  const [requests, setRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [showBeantragteBeiAntrag, setShowBeantragteBeiAntrag] = useState(false);
  const [active, setActive] = useState(null);
  const [fehlzeitenIndex, setFehlzeitenIndex] = useState(-1);
  const [fehlzeitenIndexError, setFehlzeitenIndexError] = useState(false);
  const [requestDate, setRequestDate] = useState();
  const dataChartPie = useRef([]);
  const dataChartLine = useRef([]);
  const dataChartBar = useRef([]);
  const [startDate, setStartDate] = useState(
    new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getFullYear().toString() +
      "-" +
      pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getMonth() + 1, 2) +
      "-" +
      pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getDate(), 2),
  );
  const [endDate, setEndDate] = useState(
    new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getFullYear().toString() +
      "-" +
      pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getMonth() + 1, 2) +
      "-" +
      pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getDate(), 2),
  );
  const today = new Date().getFullYear().toString() + "-" + pad(new Date().getMonth() + 1, 2) + "-" + pad(new Date().getDate(), 2);
  const [dateList, setDateList] = useState([]);
  const [comment, setComment] = useState("");
  const [travelReason, setTravelReason] = useState(-1);
  const [travelLocation, setTravelLocation] = useState(-1);
  const [travelVehicle, setTravelVehicle] = useState(-1);
  const [travelloc, setTravelloc] = useState("");
  const [reisedest, setReisedest] = useState("0");
  const [open, setOpen] = useState(false);
  const [startDateError, setStartDateError] = useState(null);
  const [endDateError, setEndDateError] = useState(null);
  const [endZeitError, setEndZeitError] = useState(null);
  const [startZeitError, setStartZeitError] = useState(null);
  const [fehlzeiten, setFehlzeiten] = useState([]);
  const [startTime, setStartTime] = useState(0);
  const [endTime, setEndTime] = useState(0);
  const [dauer, setDauer] = useState(0);
  const [fahrzeit, setFahrzeit] = useState(0);
  const [vertreter, setVertreter] = useState(-1);
  const [zeitart_select, setZeitart_select] = useState(-1);
  const [proz, setProz] = useState("");
  const [vertreterList, setVertreterList] = useState([]);
  const [reiseland, setReiseland] = useState([]);
  const [reisegrund, setReisegrund] = useState([]);
  const [reisegrund008, setReisegrund008] = useState([]);
  const [reisegrund067, setReisegrund067] = useState([]);
  const [reiseauswahl, setReiseauswahl] = useState([]);
  const [reisevkm, setReisevkm] = useState([]);
  //const [vgmode,setVgmode]=useState(false);
  const [zeiten, setZeiten] = useState([]);
  const [zahlart, setZahlart] = useState(-1);
  const [datepast, setDatepast] = useState(
    new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getFullYear().toString() +
      "-" +
      pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getMonth() + 1, 2) +
      "-" +
      pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getDate(), 2),
  );
  const [datefuture, setDatefuture] = useState(
    new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getFullYear().toString() +
      "-" +
      pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getMonth() + 1, 2) +
      "-" +
      pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getDate(), 2),
  );
  //const [meldungdirekt,setMeldungdirekt]=useState(false);
  const { hideMessage, showSuccessMessage, showErrorMessage } = useMessage();
  const [historie, setHistorie] = useState(false);
  const [onlineid, setOnlineid] = useState("");
  const [keynumber, setKeynumber] = useState(0);
  const [sdatei, setSdatei] = useState("");
  const [wdatei, setWdatei] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [needsFileUpload, setNeedsFileUpload] = useState(false);
  const [sperre, setSperre] = useState({});
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [sperreBearbeiten, setSperreBearbeiten] = useState(false);
  const [sperreStatus, setSperreStatus] = useState(-1);
  const [sperreNewstatus, setSperreNewstatus] = useState(-1);
  const [globalsperre, setGlobalsperre] = useState("");
  const [ansicht, setAnsicht] = useState(-1);
  const [jahresAnsicht, setJahresAnsicht] = useState(false);
  const [expanded, setExpanded] = useState(-1);
  const [jahr, setJahr] = useState(new Date().getFullYear());
  const [monat, setMonat] = useState(new Date().getMonth());
  const [openUrlaub, setOpenUrlaub] = useState(false);
  const [openGleitzeit, setOpenGleitzeit] = useState(false);
  const [openKranktage, setOpenKranktage] = useState(false);
  const [events, setEvents] = useState([]);
  const [legende, setLegende] = useState([]);
  const [sondertage, setSondertage] = useState([]);
  const [errFz, setErrFz] = useState(false);
  const grenze = useRef(0);

  const [datumGrenze] = useState(new Date(new Date().setDate(new Date().getDate() - 1095)));
  const [datumGrenzeFormat] = useState(datumGrenze.getFullYear().toString() + "-" + "00" + "-" + "01");
  const theme = useTheme();

  const COLORS = ["#0067a5dd", "#ffbf00dd", "#00a86bdd"];

  const { userid, admin } = useMemo(() => {
    if (searchParams && searchParams.get("userId")) {
      return {
        admin: "J",
        userid: searchParams.get("userId"),
      };
    } else {
      return {
        admin: "",
        userid: "",
      };
    }
  }, [searchParams]);

  //const [pre,setPre]=useState({})
  function ElevationScroll(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 64,
      target: window ? window() : undefined,
    });
    return <Zoom in={trigger}>{children}</Zoom>;
  }
  ElevationScroll.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
  };
  useEffect(() => {
    setAnsicht(Number(localStorage.getItem("ansicht")));
    if (localStorage.getItem(LOCAL_STORAGE_KEY.kalenderJahresAnsicht)) {
      setJahresAnsicht(localStorage.getItem(LOCAL_STORAGE_KEY.kalenderJahresAnsicht) === "J" ? true : false);
    }
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: admin === "J" ? "PMURB3" : "PMURA1",
      statement: "LADE_UEBERSICHT",
      vgmode: admin,
      id: userid,
      jahr: jahr,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, absenceCb, errorCb);
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (startDate === "") {
      setStartDateError("Bitte geben Sie ein Startdatum ein");
      return;
    }
    if (globalsperre && globalsperre > startDate) {
      setStartDateError("Für diesen Monat können keine Anpassungen mehr vorgenomen werden. Bitte wenden Sie sich für Anpassungen an Ihre Personalabteilung!");
      return;
    }
    if (startDate < datepast) {
      setStartDateError("Anträge können erst ab " + datepast.substr(8, 2) + "." + datepast.substr(5, 2) + "." + datepast.substr(0, 4) + " gestellt werden");
    } else {
      setStartDateError(null);
    }

    if (endDate === "") {
      setEndDateError("Bitte geben Sie ein Enddatum ein");
      return;
    }
    if (endDate < startDate) {
      setEndDateError("Das Enddatum darf nicht kleiner als das Startdatum sein");
    } else {
      if (endDate > datefuture) {
        setEndDateError(
          "Anträge können nur bis " + datefuture.substr(8, 2) + "." + datefuture.substr(5, 2) + "." + datefuture.substr(0, 4) + " gestellt werden",
        );
      } else {
        setEndDateError(null);
      }
    }
    DateList();
    // eslint-disable-next-line
  }, [endDate]);
  useEffect(() => {
    if (startDate === "") {
      setStartDateError("Bitte geben Sie ein Startdatum ein");
      return;
    }
    if (globalsperre && globalsperre > startDate) {
      setStartDateError("Für diesen Monat können keine Anpassungen mehr vorgenomen werden. Bitte wenden Sie sich für Anpassungen an Ihre Personalabteilung!");
      return;
    }
    if (startDate < datepast) {
      setStartDateError("Anträge können erst ab " + datepast.substr(8, 2) + "." + datepast.substr(5, 2) + "." + datepast.substr(0, 4) + " gestellt werden");
    } else {
      setStartDateError(null);
    }
    if (startDate > endDate) {
      setEndDate(startDate);
    }
    if (endDate === "") {
      setEndDateError("Bitte geben Sie ein Enddatum ein");
      return;
    }
    if (endDate < startDate) {
      setEndDateError("Das Enddatum darf nicht kleiner als das Startdatum sein");
    } else {
      if (endDate > datefuture) {
        setEndDateError(
          "Anträge können nur bis " + datefuture.substr(8, 2) + "." + datefuture.substr(5, 2) + "." + datefuture.substr(0, 4) + " gestellt werden",
        );
      } else {
        setEndDateError(null);
      }
    }
    DateList();
    // eslint-disable-next-line
  }, [startDate]);

  useEffect(() => {
    if (fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].zusatz_zeiten && (!zeiten || zeiten.length === 0)) NewLine();
    if (fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].zkor && fehlzeiten[fehlzeitenIndex].zkor.length === 1) {
      setZahlart(0);
    } else {
      setZahlart(-1);
    }
    // eslint-disable-next-line
  }, [fehlzeitenIndex]);

  useEffect(() => {
    console.log(startTime);
    console.log(endTime);
    if (fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].uhrzeit_pflicht === "1" && !startTime) {
      setStartZeitError("Eingabe erforderlich");
    } else {
      setStartZeitError(null);
    }
    if (fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].uhrzeit_pflicht === "1" && !endTime) {
      setEndZeitError("Eingabe erforderlich");
    } else {
      setEndZeitError(null);
    }
  }, [fehlzeitenIndex, startTime, endTime]);

  function ResetData() {
    setOpen(false);
    setTravelReason(-1);
    setTravelLocation(-1);
    setTravelVehicle(-1);
    setTravelloc("");
    setFahrzeit(0);
    setVertreter(-1);
    setVertreter(-1);
    setProz("");
    setStartTime(0);
    setEndTime(0);
    setDauer(0);
    setRequestDate();
    setStartDate(
      new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getFullYear().toString() +
        "-" +
        pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getMonth() + 1, 2) +
        "-" +
        pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getDate(), 2),
    );
    setEndDate(
      new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getFullYear().toString() +
        "-" +
        pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getMonth() + 1, 2) +
        "-" +
        pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getDate(), 2),
    );
    setFehlzeitenIndex(-1);
    setReiseauswahl(reisegrund);
    setZeiten([]);
    setZahlart(-1);
    setNeedsFileUpload(false);
  }
  function ValidateSetProz(value) {
    if (Number(value) <= 100) {
      setProz(value);
    }
  }
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  function DateList() {
    var tmplist = [];
    var tmpvon = DateToJulian(new Date(startDate.substr(0, 4), (Number(startDate.substr(5, 2)) - 1).toString(), startDate.substr(8, 2)));
    var tmpbis = DateToJulian(new Date(endDate.substr(0, 4), (Number(endDate.substr(5, 2)) - 1).toString(), endDate.substr(8, 2)));
    var tmptoday = DateToJulian(new Date(today.substr(0, 4), (Number(today.substr(5, 2)) - 1).toString(), today.substr(8, 2)));
    if (tmpvon < DateToJulian(new Date("2010", "01", "01"))) return;
    for (var i = tmpvon; i <= tmpbis; i++) {
      if (i <= tmptoday) {
        var tmpdate = JulianToDate(i);
        var tmpdaterev = moment(tmpdate.getFullYear().toString() + "-" + pad(tmpdate.getMonth() + 1, 2) + "-" + pad(tmpdate.getDate(), 2));
        var day = tmpdaterev.day();
        var daybez = "";
        if (day === 1) daybez = "Montag";
        if (day === 2) daybez = "Dienstag";
        if (day === 3) daybez = "Mittwoch";
        if (day === 4) daybez = "Donnerstag";
        if (day === 5) daybez = "Freitag";
        if (day === 6) daybez = "Samstag";
        if (day === 0) daybez = "Sonntag";
        tmpdate = pad(tmpdate.getDate(), 2) + "." + pad(tmpdate.getMonth() + 1, 2) + "." + tmpdate.getFullYear().toString() + " - " + daybez;
        tmplist.push(tmpdate);
      }
    }
    if (!tmplist || tmplist.length < 1) {
      var tmpzeiten = [];
      tmpzeiten.push({
        taglfd: "",
        zeitlfd: "",
        vzeit: "00:00",
        bzeit: "00:00",
        datum: "",
        za_key: "",
      });
    }

    setDateList(tmplist);
  }
  const openMessageBox = () => {
    setMessageBoxOpen(true);
  };
  const closeMessageBox = () => {
    setMessageBoxOpen(false);
  };
  function handleAnsichtChange(kz) {
    setJahresAnsicht(kz);
    localStorage.setItem(LOCAL_STORAGE_KEY.kalenderJahresAnsicht, kz ? "J" : "N");
  }

  const absenceCb = (response) => {
    if (response.status === 200) {
      setRequests(response.data.request);
      setShowBeantragteBeiAntrag(response.data.showBeantragteBeiAntrag);
      setSalden(response.data.salden);
      setOnlineid(response.data.onlineid);
      setKeynumber(keynumber + 1);
      setSdatei(response.data.sdatei && response.data.sdatei);
      setWdatei(response.data.wdatei && response.data.wdatei);
      if (response.data.fehlzeiten) {
        setFehlzeiten(response.data.fehlzeiten);
      }
      if (response.data.globalsperre) {
        setGlobalsperre(response.data.globalsperre);
      }
      if (response.data.vertreter) {
        setVertreterList(response.data.vertreter);
      }
      if (response.data.reiseland) {
        setReiseland(response.data.reiseland);
      }
      if (response.data.reisevkm) {
        setReisevkm(response.data.reisevkm);
      }
      if (response.data.reisegrund) {
        setReisegrund(response.data.reisegrund);
        setReiseauswahl(response.data.reisegrund);
      }
      if (response.data.reisegrund008) {
        setReisegrund008(response.data.reisegrund008);
      }
      if (response.data.reisegrund067) {
        setReisegrund067(response.data.reisegrund067);
      }
      if (response.data.sperre) {
        setSperre(response.data.sperre);
      }
      if (response.data.grenze) {
        grenze.current = response.data.grenze;
      }

      setEvents(response.data.events || []);
      setLegende(response.data.legende || []);
      setSondertage(response.data.sondertage || []);
      setDatepast(response.data.datepast);
      setDatefuture(response.data.datefuture);
      if (response.data.reisedest) {
        setReisedest(response.data.reisedest);
      }
      if (admin === "J") updateTitle("Mitarbeiter Abwesenheit (" + response.data.bearb_name + ")");
      setIsLoading(false);
      setIsSending(false);
      hideMessage();
    } else {
      setIsSending(false);
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  function jahresWechsel(year, month) {
    let newYear = year;
    let newMonth = month !== undefined && month !== null ? month : monat;
    if (year.toString() + pad(newMonth.toString(), 2) < datumGrenzeFormat.replace(/-/g, "") && admin === "J") {
      newMonth = parseInt(datumGrenzeFormat.toString().substring(5, 7));
      newYear = parseInt(datumGrenzeFormat.toString().substring(0, 4));
      if (newYear === jahr && newMonth === monat) {
        showErrorMessage(t("Rückblick nur bis " + datumGrenzeFormat.toString().substring(0, 4) + " erlaubt"));
        return;
      }
    }
    setIsSending(true);
    setJahr(newYear);
    setMonat(newMonth);
    const payload = {
      mandant: client,
      program: admin === "J" ? "PMURB3" : "PMURA1",
      statement: "LADE_UEBERSICHT",

      vgmode: admin,
      id: userid,
      jahr: newYear,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, absenceCb);
  }

  function monatsWechsel(next = true) {
    let tmpMonth = monat;
    if (next) {
      tmpMonth += 1;
      if (tmpMonth === 12) {
        jahresWechsel(jahr + 1, 0);
      } else {
        setMonat(tmpMonth);
      }
    } else {
      tmpMonth -= 1;
      if (tmpMonth === -1) {
        if (jahr - 1 + "11" < datumGrenzeFormat.substring(0, 6)) {
          showErrorMessage(t("Rückblick nur bis " + datumGrenzeFormat.toString().substring(0, 4) + " erlaubt"));
          return;
        }
        jahresWechsel(jahr - 1, 11);
      } else {
        setMonat(tmpMonth);
      }
    }
  }

  function Sperre(kz, bearbeiten, status, newstatus) {
    if (kz === "2") {
      if (bearbeiten === "J") {
        setSperreBearbeiten(true);
        setSperreStatus(status);
        setSperreNewstatus(newstatus);
      }
      setSperreNewstatus(newstatus);
      openMessageBox();
    }
  }
  function messageBoxResult(r) {
    if (r === "YES") {
      if (sperreBearbeiten === true) {
        handleEditAbsenceClick(sperreStatus, sperreNewstatus, "");
      } else {
        handleNewAbsenceClick(sperreNewstatus, "");
      }
    }
    setSperreBearbeiten(false);
    setSperreStatus(-1);
    setSperreNewstatus(-1);
    closeMessageBox();
  }
  const newAbsenceCb = (response) => {
    if (response.status === 200) {
      if (response.data.grenze) {
        grenze.current = response.data.grenze;
      }
      if (response.data.gesperrt === "2") {
        setIsSending(false);
        Sperre(response.data.gesperrt, response.data.bearbeiten, response.data.status, response.data.newstatus);
        return;
      }
      if (response.data.gesperrt === "1") {
        setIsSending(false);
        showErrorMessage(t("Antrag kann nicht gestellt werden, da der Kontostand unter " + response.data.grenze.toString() + " fallen würde"));
        return;
      }
      if (response.data.gesperrt === "3") {
        setIsSending(false);
        showErrorMessage(t("Antrag kann nicht gestellt werden, da der Kontostand bereits auf/unter " + response.data.grenze.toString() + " liegt"));
        return;
      }
      showSuccessMessage(t("Antrag erfolgreich"));
      setEvents(response.data.events || []);
      ResetData();
      setStartDateError(null);
      setEndDateError(null);
      setEndZeitError(null);
      setStartZeitError(null);
      setFehlzeitenIndex(-1);
      setReiseauswahl(reisegrund);
      setProz("");
      setZeiten([]);
      setZahlart(-1);
      setStartDate(
        new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getFullYear().toString() +
          "-" +
          pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getMonth() + 1, 2) +
          "-" +
          pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getDate(), 2),
      );
      setEndDate(
        new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getFullYear().toString() +
          "-" +
          pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getMonth() + 1, 2) +
          "-" +
          pad(new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1).getDate(), 2),
      );
      setComment("");
      setRequests(response.data.request);
      setKeynumber(keynumber + 1);
      setSalden(response.data.salden);
      setVertreterList(response.data.vertreter);
      setReisegrund(response.data.reisegrund);
      setReiseauswahl(response.data.reisegrund);
      setReisegrund008(response.data.reisegrund008);
      setReisegrund067(response.data.reisegrund067);
      response.data.reiseland ? setReiseland(response.data.reiseland) : setReiseland([]);
      setReisevkm(response.data.reisevkm);
      setDatepast(response.data.datepast);
      setDatefuture(response.data.datefuture);
      setReisedest(response.data.reisedest);
      setLegende(response.data.legende || []);
      setSondertage(response.data.sondertage || []);
      hideMessage();
      setIsSending(false);
    } else {
      setIsSending(false);
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const handleNewAbsenceClick = (newstatus, uebsperre) => {
    if (zeiten) {
      var fehler = Zeitencheck();
      if (fehler && fehler !== "") {
        showErrorMessage(fehler);
        return;
      }
    }
    if (fehlzeiten[fehlzeitenIndex].min && fehlzeiten[fehlzeitenIndex].max > 0) {
      if (Number(proz) < Number(fehlzeiten[fehlzeitenIndex].min)) {
        showErrorMessage(t("Auszahlungsprozent muss mindestens ") + fehlzeiten[fehlzeitenIndex].min + " betragen");
        return;
      }
      if (Number(proz) > Number(fehlzeiten[fehlzeitenIndex].max)) {
        showErrorMessage(t("Auszahlungsprozent darf maximal ") + fehlzeiten[fehlzeitenIndex].max + " betragen");
        return;
      }
    }
    if (fehlzeiten[fehlzeitenIndex].proz) {
      if (!proz || proz === "") {
        showErrorMessage(t("Bitte wählen Sie einen Wert bei Auszahlungsprozent aus"));
        return;
      }
    }
    if (!startDateError && !endDateError && !startZeitError && !endZeitError) {
      if (fehlzeitenIndex < 0) {
        showErrorMessage(t("Bitte wählen Sie die Abwesenheitsart aus"));
        return;
      }
      if (active !== null) {
        handleEditAbsenceClick(requests[active].status, newstatus, uebsperre);
        return;
      }
      if (
        dateList &&
        dateList.length > 0 &&
        fehlzeiten.length > 0 &&
        fehlzeiten[fehlzeitenIndex] &&
        fehlzeiten[fehlzeitenIndex].zkor &&
        fehlzeiten[fehlzeitenIndex].zkor.length > 0 &&
        zeiten &&
        zeiten.length > 0 &&
        zahlart < 0
      ) {
        showErrorMessage(t("Bitte wählen Sie eine Vergütungsart aus"));
        return;
      }
      if (startTime && startTime === endTime && Number(startTime.replace(":", ".")) !== 0) {
        showErrorMessage(t("Von Zeit und Bis Zeit dürfen nicht idenisch sein"));
        return;
      }

      if (
        DateToJulian(new Date(endDate.substr(0, 4), (Number(endDate.substr(5, 2)) - 1).toString(), endDate.substr(8, 2))) -
          DateToJulian(new Date(startDate.substr(0, 4), (Number(startDate.substr(5, 2)) - 1).toString(), startDate.substr(8, 2))) >
        365
      ) {
        showErrorMessage(t("Abwesenheit darf nicht länger als 365 Tage gehen"));
        return;
      }

      const payload = {
        mandant: client,
        program: admin === "J" ? "PMURB3" : "PMURA1",
        statement: "SCHREIBE_ANTRAG",
        "status-neu": newstatus,
        vgmode: admin,
        id: userid,
        sperre: uebsperre,
        art: fehlzeiten[fehlzeitenIndex].art,
        jahr: jahr,
        FELD: {
          "WURG-KEY": "",
          "WURG-VDAT": startDate.slice(0, 4) + startDate.slice(5, 7) + startDate.slice(8, 10),
          "WURG-BDAT": endDate.slice(0, 4) + endDate.slice(5, 7) + endDate.slice(8, 10),
          "WURG-VZEIT": startTime,
          "WURG-BZEIT": endTime,
          "WURG-FZEIT": fahrzeit,
          "WURG-URLNR": fehlzeiten[fehlzeitenIndex].key,
          "WURG-HINWAN": comment,
          "WURG-REISE_ORT": travelloc,
          "WURG-REISE_GRUND": travelReason > -1 ? reiseauswahl[travelReason].key : "",
          "WURG-REISE_LAND": travelLocation > -1 ? reiseland[travelLocation].key : "",
          "WURG-REISE_VKM": travelVehicle > -1 ? reisevkm[travelVehicle].key : "",
          "WURG-VERT": vertreter > -1 ? vertreterList[vertreter].id : "",
          "WURG-PROZ": proz,
          ZAHLART: zahlart > -1 ? fehlzeiten[fehlzeitenIndex].zkor[zahlart].key : "",
          ZEITEN: zeiten && zeiten.length > 0 ? zeiten : [],
          "WURG-DAUER": dauer,
        },
      };
      const headers = {
        Authorization: "Bearer " + accessToken,
      };
      setIsSending(true);
      apiRequest("POST", "daten", payload, headers, newAbsenceCb);
    }
  };

  const errorCb = () => {
    showErrorMessage(t("Es konnte keine Verbindung aufgebaut werden"));
    setIsSending(false);
    setIsLoading(false);
  };
  const handleEditAbsenceClick = (oldstatus, newstatus, uebsperre) => {
    const zeitart = () => {
      if (fehlzeiten[fehlzeitenIndex].ZEITART === undefined || fehlzeiten[fehlzeitenIndex].ZEITART === null) {
        return "";
      }
      if (zeitart_select > -1) {
        return fehlzeiten[fehlzeitenIndex].ZEITART[zeitart_select].KEY;
      }
      if (fehlzeiten[fehlzeitenIndex].ZEITART.length === 1) {
        return fehlzeiten[fehlzeitenIndex].ZEITART[0].KEY;
      }
      return "";
    };
    let a = zeitart();
    const payload = {
      vgmode: admin,
      id: userid,
      mandant: client,
      program: admin === "J" ? "PMURB3" : "PMURA1",
      statement: "BEARBEITE_ANTRAG",
      "status-neu": newstatus,
      status: oldstatus,
      absencekey: requests[active].key,
      sperre: uebsperre,
      art: fehlzeiten[fehlzeitenIndex].art,
      jahr: jahr,
      FELD: {
        "WURG-KEY": "",
        "WURG-VDAT": startDate.slice(0, 4) + startDate.slice(5, 7) + startDate.slice(8, 10),
        "WURG-BDAT": endDate.slice(0, 4) + endDate.slice(5, 7) + endDate.slice(8, 10),
        "WURG-VZEIT": startTime,
        "WURG-BZEIT": endTime,
        "WURG-FZEIT": fahrzeit,
        "WURG-URLNR": fehlzeiten[fehlzeitenIndex].key,
        "WURG-HINWAN": comment,
        "WURG-REISE_ORT": travelloc,
        "WURG-REISE_GRUND": travelReason > -1 ? reiseauswahl[travelReason].key : "",
        "WURG-REISE_LAND": travelLocation > -1 ? reiseland[travelLocation].key : "",
        "WURG-REISE_VKM": travelVehicle > -1 ? reisevkm[travelVehicle].key : "",
        "WURG-VERT": vertreter > -1 ? vertreterList[vertreter].id : "",
        "WURG-ZART": zeitart(),
        "WURG-PROZ": proz,
        ZAHLART: zahlart > -1 ? fehlzeiten[fehlzeitenIndex].zkor[zahlart].key : "",
        ZEITEN: zeiten && zeiten.length > 0 ? zeiten : [],
        "WURG-DAUER": dauer,
      },
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    setIsSending(true);
    apiRequest("POST", "daten", payload, headers, newAbsenceCb);
  };

  const handleAbsenceActionClick = (count) => {
    if (requests[count].status !== "0" && requests[count].status !== "7") {
      if (admin === "J") {
        navigate("/PMURB3/PMURA1/antragdetailsuser/" + requests[count].key + "?userId=" + userid);
      } else {
        navigate("/PMURA1/antragdetailsuser/" + requests[count].key);
      }
      return;
    }
    setActive(count);
    setOpen(true);

    setStartDate(requests[count].vdat);
    setRequestDate(requests[count].antragdat);
    setEndDate(requests[count].bdat);
    setStartTime(requests[count].vzeit);
    setFahrzeit(requests[count].fzeit);
    setEndTime(requests[count].bzeit);
    setComment(requests[count].hinweis);
    setProz(requests[count].proz);
    if (requests[count].zeiten) {
      setZeiten(requests[count].zeiten);
    }

    setTravelloc(requests[count].reiseort);
    fehlzeiten?.forEach((fz, index) => {
      if (fz.key === requests[count].fzkey) {
        setFehlzeitenIndex(index);

        if (fz.zkor) {
          fz.zkor.forEach((item, index2) => {
            if (item.key === requests[count].korropt) {
              setZahlart(index2);
            }
          });
        }
      }
    });

    vertreterList?.forEach((vert, index) => {
      if (vert.id === requests[count].vertreter) {
        setVertreter(index);
      }
    });
    if (reisegrund008 && reisegrund008.length > 0 && requests[count].fzkey === "008") {
      setReiseauswahl(reisegrund008);
      reisegrund008?.forEach((reise, index) => {
        if (reise.key === requests[count].reisegrund) {
          setTravelReason(index);
        }
      });
    } else if (reisegrund067 && reisegrund067.length > 0 && requests[count].fzkey === "067") {
      setReiseauswahl(reisegrund067);
      reisegrund067?.forEach((reise, index) => {
        if (reise.key === requests[count].reisegrund) {
          setTravelReason(index);
        }
      });
    } else {
      reisegrund?.forEach((reise, index) => {
        if (reise.key === requests[count].reisegrund) {
          setTravelReason(index);
        }
      });
    }

    reiseland?.forEach((reise, index) => {
      if (reise.key === requests[count].reiseland) {
        setTravelLocation(index);
      }
    });
    reisevkm?.forEach((reise, index) => {
      if (reise.key === requests[count].reisevkm) {
        setTravelVehicle(index);
        return;
      }
    });
  };
  function Zeitencheck() {
    if (!zeiten) return false;
    if (zeiten.length < 1) return false;
    var fehler = false;
    zeiten.forEach((item, index) => {
      if (fehler) {
        return;
      }
      if (Number(item.datum) === 0 && (item.vzeit !== "00:00" || item.bzeit !== "00:00")) {
        fehler = "Bitte vervollständigen Sie Ihre Eingabe in der " + String(index + 1) + ". Arbeitszeit";
        return;
      }

      if (Number(item.datum) !== 0 && fehlzeiten[fehlzeitenIndex].ZEITART !== undefined && fehlzeiten[fehlzeitenIndex].ZEITART.length === 1) {
        item.za_key = fehlzeiten[fehlzeitenIndex].ZEITART[0].KEY;
      } else if (
        Number(item.datum) !== 0 &&
        fehlzeiten[fehlzeitenIndex].ZEITART !== undefined &&
        item.za_key === "" &&
        fehlzeiten[fehlzeitenIndex].ZEITART.length > 0
      ) {
        fehler = "Bitte geben Sie eine Zeitart an!";
        return;
      }
      if (Number(item.datum) !== 0 && item.vzeit === "00:00" && item.bzeit === "00:00") {
        fehler = "Bitte vervollständigen Sie Ihre Eingabe in der " + String(index + 1) + ". Arbeitszeit";
        return;
      }
    });
    return fehler;
  }
  function Delete(index) {
    const payload = {
      mandant: client,
      program: admin === "J" ? "PMURB3" : "PMURA1",
      statement: "LOESCHE_ANTRAG",
      absence: requests[index].key,
      status: requests[index].status,
      vgmode: admin,
      id: userid,
      jahr: jahr,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    setIsSending(true);
    apiRequest("POST", "daten", payload, headers, deleteCB);
  }
  const deleteCB = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      ResetData();
      setEvents(response.data.events || []);
      setActive(null);
      setRequests(response.data.request);
      setKeynumber(keynumber + 1);
      setSalden(response.data.salden);
      if (response.data.fehlzeiten) {
        setFehlzeiten(response.data.fehlzeiten);
      }
      setVertreterList(response.data.vertreter);
      setReisegrund008(response.data.reisegrund008);
      setReisegrund067(response.data.reisegrund067);
      setReisegrund(response.data.reisegrund);
      setReiseauswahl(response.data.reisegrund);
      response.data.reiseland ? setReiseland(response.data.reiseland) : setReiseland([]);
      setReisevkm(response.data.reisevkm);
      setDatepast(response.data.datepast);
      setDatefuture(response.data.datefuture);
      setReisedest(response.data.reisedest);
      setLegende(response.data.legende || []);
      setSondertage(response.data.sondertage || []);
      setZeiten([]);
      hideMessage();
      setIsSending(false);
    } else {
      setIsSending(false);
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  function Sonderurlaub() {
    setShowModal(true);
    const payload = {
      mandant: client,
      program: admin === "J" ? "PMURB3" : "PMURA1",
      statement: "PDF_SONDERURLAUB",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = "Richtlinien.pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setShowModal(false);
      })
      .catch(function (error) {
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
        setShowModal(false);
      });
  }
  function Wertguthaben() {
    setShowModal(true);
    const payload = {
      mandant: client,
      program: admin === "J" ? "PMURB3" : "PMURA1",
      statement: "PDF_WERTGUTHABEN",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = "Richtlinien.pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setShowModal(false);
      })
      .catch(function (error) {
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
        setShowModal(false);
      });
  }
  function NewLine() {
    var tmpliste = [...zeiten];
    tmpliste.push({
      taglfd: "",
      zeitlfd: "",
      vzeit: "00:00",
      bzeit: "00:00",
      datum: "",
      za_select: "",
      za_key: "",
    });
    setZeiten(tmpliste);
  }
  function ChangeZeiten(val, op, index) {
    var tmpliste = [];
    if (op === "datum") {
      tmpliste = [...zeiten];
      tmpliste[index].datum = val;
    }
    if (op === "vonzeit") {
      tmpliste = [...zeiten];
      tmpliste[index].vzeit = val;
    }
    if (op === "biszeit") {
      tmpliste = [...zeiten];
      tmpliste[index].bzeit = val;
    }
    if (op === "del") {
      tmpliste = [];
      zeiten.forEach((item, index2) => {
        if (index !== index2)
          tmpliste.push({
            taglfd: item.taglfd,
            zeitlfd: item.zeitlfd,
            vzeit: item.vzeit,
            bzeit: item.bzeit,
            datum: item.datum,
            za_key: item.za_key,
          });
      });
    }
    setZeiten(tmpliste);
  }
  function ChangeReisegrund(fz) {
    if (fehlzeiten[fz] && fehlzeiten[fz].key === "008" && reisegrund008 && reisegrund008.length > 0) {
      setReiseauswahl(reisegrund008);
    } else if (fehlzeiten[fz] && fehlzeiten[fz].key === "067" && reisegrund067 && reisegrund067.length > 0) {
      setReiseauswahl(reisegrund067);
    } else {
      setReiseauswahl(reisegrund);
    }
  }

  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, name, value }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const RADIAN = Math.PI / 180;
    const x = cx + (value > 100 ? radius - 5 : radius) * Math.cos(-(midAngle ?? 0) * RADIAN);
    const y = cy + (value > 100 ? radius - 5 : radius) * Math.sin(-(midAngle ?? 0) * RADIAN);

    if (value <= 0) return;
    return (
      <text x={x} y={y} fill={"white"} textAnchor={x > 50 ? "start" : "end"} dominantBaseline="central">
        {value}
      </text>
    );
  };

  // row.remains
  // row.year
  // row.taken
  // row.genommen
  // row.korrektur
  // row.ausgezahlt
  // row.verfallen
  // row.final
  // row.current
  // row.planed

  function Kontenstaende() {
    return (
      <Grid container spacing={2} p={2}>
        {salden
          ?.filter((e) => !e.noShow)
          .map(
            (row, count) =>
              (row.typ !== "2" || today.substr(0, 4) >= jahr) && (
                <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
                  <Card key={count} onClick={() => OpenRD(row, count)}>
                    <CardContent>
                      {row.typ === "1" && Urlaubskonto(row)}
                      {row.typ === "2" && Gleitzeitkonto(row)}
                      {row.typ === "3" && Kranktage(row)}
                    </CardContent>
                  </Card>
                </Grid>
              ),
          )}
      </Grid>
    );
  }

  function Urlaubskonto(row) {
    dataChartPie.current = [
      { name: "genommen", value: -Number(row.taken) + Number(row.planed) },
      { name: "verplant", value: -Number(row.planed) },
      { name: "unverplant", value: Number(row.final) },
    ];
    if (today.substr(0, 4) > jahr) {
      dataChartPie.current = [
        { name: "genommen", value: -Number(row.taken) },
        { name: "verplant", value: 0 },
        { name: "unverplant", value: Number(row.gesamtanspruch) + Number(row.taken) },
      ];
    }

    return (
      <Grid container spacing={0} justifyContent={"center"} alignContent={"center"}>
        <Grid item xs={1} fontWeight={5}></Grid>
        <Grid item xs={10} fontWeight={5}>
          <Typography fontWeight={"bold"}>{row.text}</Typography>
        </Grid>
        <Grid item xs={1} fontWeight={5}>
          <IconButton sx={{ m: 0, p: 0 }} variant="contained" color="info">
            <InfoIcon />
          </IconButton>
        </Grid>

        <Grid item xs={12}>
          <Grid container rowSpacing={1} justifyContent={"center"} alignContent={"center"}>
            <Grid item xs={4}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography fontWeight={700} color="#616161ff">
                    {row.gesamtanspruch.toString()}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography fontSize={12} color="#616161ff">
                    {"Anspruch"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography fontWeight={900}>{today.substr(0, 4) <= jahr ? row.final.toString() : "0.00"}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography fontSize={12}>{"unverplant"}</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography color="#616161ff" fontWeight={700}>
                    {today.substr(0, 4) <= jahr ? row.current.toString() : row.final}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography fontSize={12} color="#616161ff">
                    {today.substr(0, 4) <= jahr ? "Heute" : "Ende " + jahr}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6} justifyContent={"center"} alignContent={"center"} pt={2}>
          <div style={{ justifyContent: "center", alignContent: "center", display: "flex" }}>
            <PieChart width={106} height={106}>
              <Pie data={dataChartPie.current} cx={"50%"} cy={"50%"} innerRadius={30} outerRadius={50} dataKey="value" labelLine={false}>
                {dataChartPie.current.map((entry, index) => (
                  <ChartCell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} stroke="none" />
                ))}
              </Pie>
            </PieChart>
          </div>
        </Grid>
        <Grid item xs={6} pt={2}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div style={{ justifyContent: "left", alignContent: "center", display: "flex" }}>
                <Badge
                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: COLORS[0],
                    },
                  }}
                  badgeContent=""
                  anchorOrigin={{
                    vertical: "cente",
                    horizontal: "center",
                  }}
                ></Badge>
                <Typography fontSize={"14px"} pl={3}>
                  {dataChartPie.current[0].value} verbraucht
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div style={{ justifyContent: "left", alignContent: "center", display: "flex" }}>
                <Badge
                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: COLORS[1],
                    },
                  }}
                  badgeContent=""
                  anchorOrigin={{
                    vertical: "cente",
                    horizontal: "center",
                  }}
                ></Badge>
                <Typography fontSize={"14px"} pl={3}>
                  {dataChartPie.current[1].value} verplant
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div style={{ justifyContent: "left", alignContent: "center", display: "flex" }}>
                <Badge
                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: COLORS[2],
                    },
                  }}
                  badgeContent=""
                  anchorOrigin={{
                    vertical: "cente",
                    horizontal: "center",
                  }}
                ></Badge>
                <Typography fontSize={"14px"} pl={3}>
                  {dataChartPie.current[2].value} {today.substr(0, 4) <= jahr ? "unverplant" : "übertragen"}
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  function Gleitzeitkonto(row) {
    dataChartLine.current = [{ name: "00", value: Number(row.ueb) }];
    if (Number(today.substr(5, 2)) >= 1 || today.substr(0, 4) > jahr) dataChartLine.current.push({ name: "01", value: Number(row.ueb) + Number(row.m1) });
    if (Number(today.substr(5, 2)) >= 2 || today.substr(0, 4) > jahr)
      dataChartLine.current.push({ name: "02", value: Number(row.ueb) + Number(row.m1) + Number(row.m2) });
    if (Number(today.substr(5, 2)) >= 3 || today.substr(0, 4) > jahr)
      dataChartLine.current.push({ name: "03", value: Number(row.ueb) + Number(row.m1) + Number(row.m2) + Number(row.m3) });
    if (Number(today.substr(5, 2)) >= 4 || today.substr(0, 4) > jahr)
      dataChartLine.current.push({ name: "04", value: Number(row.ueb) + Number(row.m1) + Number(row.m2) + Number(row.m3) + Number(row.m4) });
    if (Number(today.substr(5, 2)) >= 5 || today.substr(0, 4) > jahr)
      dataChartLine.current.push({
        name: "05",
        value: Number(row.ueb) + Number(row.m1) + Number(row.m2) + Number(row.m3) + Number(row.m4) + Number(row.m5),
      });
    if (Number(today.substr(5, 2)) >= 6 || today.substr(0, 4) > jahr)
      dataChartLine.current.push({
        name: "06",
        value: Number(row.ueb) + Number(row.m1) + Number(row.m2) + Number(row.m3) + Number(row.m4) + Number(row.m5) + Number(row.m6),
      });
    if (Number(today.substr(5, 2)) >= 7 || today.substr(0, 4) > jahr)
      dataChartLine.current.push({
        name: "07",
        value: Number(row.ueb) + Number(row.m1) + Number(row.m2) + Number(row.m3) + Number(row.m4) + Number(row.m5) + Number(row.m6) + Number(row.m7),
      });
    if (Number(today.substr(5, 2)) >= 8 || today.substr(0, 4) > jahr)
      dataChartLine.current.push({
        name: "08",
        value:
          Number(row.ueb) +
          Number(row.m1) +
          Number(row.m2) +
          Number(row.m3) +
          Number(row.m4) +
          Number(row.m5) +
          Number(row.m6) +
          Number(row.m7) +
          Number(row.m8),
      });
    if (Number(today.substr(5, 2)) >= 9 || today.substr(0, 4) > jahr)
      dataChartLine.current.push({
        name: "09",
        value:
          Number(row.ueb) +
          Number(row.m1) +
          Number(row.m2) +
          Number(row.m3) +
          Number(row.m4) +
          Number(row.m5) +
          Number(row.m6) +
          Number(row.m7) +
          Number(row.m8) +
          Number(row.m9),
      });
    if (Number(today.substr(5, 2)) >= 10 || today.substr(0, 4) > jahr)
      dataChartLine.current.push({
        name: "10",
        value:
          Number(row.ueb) +
          Number(row.m1) +
          Number(row.m2) +
          Number(row.m3) +
          Number(row.m4) +
          Number(row.m5) +
          Number(row.m6) +
          Number(row.m7) +
          Number(row.m8) +
          Number(row.m9) +
          Number(row.m10),
      });
    if (Number(today.substr(5, 2)) >= 11 || today.substr(0, 4) > jahr)
      dataChartLine.current.push({
        name: "11",
        value:
          Number(row.ueb) +
          Number(row.m1) +
          Number(row.m2) +
          Number(row.m3) +
          Number(row.m4) +
          Number(row.m5) +
          Number(row.m6) +
          Number(row.m7) +
          Number(row.m8) +
          Number(row.m9) +
          Number(row.m10) +
          Number(row.m11),
      });
    if (Number(today.substr(5, 2)) >= 12 || today.substr(0, 4) > jahr)
      dataChartLine.current.push({
        name: "12",
        value:
          Number(row.ueb) +
          Number(row.m1) +
          Number(row.m2) +
          Number(row.m3) +
          Number(row.m4) +
          Number(row.m5) +
          Number(row.m6) +
          Number(row.m7) +
          Number(row.m8) +
          Number(row.m9) +
          Number(row.m10) +
          Number(row.m11) +
          Number(row.m12),
      });

    return (
      <Grid container spacing={0} justifyContent={"center"} alignContent={"center"}>
        <Grid item xs={1} fontWeight={5}></Grid>
        <Grid item xs={10} fontWeight={5}>
          <Typography fontWeight={"bold"}>{row.text}</Typography>
        </Grid>
        <Grid item xs={1} fontWeight={5}>
          <IconButton sx={{ m: 0, p: 0 }} variant="contained" color="info">
            <InfoIcon />
          </IconButton>
        </Grid>
        <Grid item xs={12}>
          <Grid container rowSpacing={1} justifyContent={"center"} alignContent={"center"}>
            <Grid item xs={12}>
              <div style={{ justifyContent: "center", alignContent: "center", display: "flex" }}>
                <Typography pr={1}>{today.substr(0, 4) > jahr ? "Stand zum 01.01:" : "Stand heute:"}</Typography>
                <Typography fontWeight={900}>{row.current}</Typography>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} justifyContent={"center"} alignContent={"center"}>
          <div style={{ justifyContent: "center", alignContent: "center", display: "flex" }}>
            <LineChart width={250} height={140} data={dataChartLine.current} margin={{}}>
              <XAxis fontSize={12} height={20} dataKey="name" />
              <YAxis fontSize={12} width={30} />
              <Line type="monotone" dataKey="value" stroke={COLORS[0]} strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </div>
        </Grid>
      </Grid>
    );
  }

  function Kranktage(row) {
    dataChartBar.current = [
      { name: "01", value: Number(row.m1) === NaN ? 0 : Number(row.m1) },
      { name: "02", value: Number(row.m2) === NaN ? 0 : Number(row.m2) },
      { name: "03", value: Number(row.m3) === NaN ? 0 : Number(row.m3) },
      { name: "04", value: Number(row.m4) === NaN ? 0 : Number(row.m4) },
      { name: "05", value: Number(row.m5) === NaN ? 0 : Number(row.m5) },
      { name: "06", value: Number(row.m6) === NaN ? 0 : Number(row.m6) },
      { name: "07", value: Number(row.m7) === NaN ? 0 : Number(row.m7) },
      { name: "08", value: Number(row.m8) === NaN ? 0 : Number(row.m8) },
      { name: "09", value: Number(row.m9) === NaN ? 0 : Number(row.m9) },
      { name: "10", value: Number(row.m10) === NaN ? 0 : Number(row.m10) },
      { name: "11", value: Number(row.m11) === NaN ? 0 : Number(row.m11) },
      { name: "12", value: Number(row.m12) === NaN ? 0 : Number(row.m12) },
    ];

    return (
      <Grid container spacing={0} justifyContent={"center"} alignContent={"center"}>
        <Grid item xs={1} fontWeight={5}></Grid>
        <Grid item xs={10} fontWeight={5}>
          <Typography fontWeight={"bold"}>{row.text}</Typography>
        </Grid>
        <Grid item xs={1} fontWeight={5}>
          <IconButton sx={{ m: 0, p: 0 }} variant="contained" color="info">
            <InfoIcon />
          </IconButton>
        </Grid>
        <Grid item xs={12}>
          <Grid container rowSpacing={1} justifyContent={"center"} alignContent={"center"}>
            <Grid item xs={12}>
              <div style={{ justifyContent: "center", alignContent: "center", display: "flex" }}>
                <Typography fontWeight={900}>{row.summe}</Typography>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} justifyContent={"center"} alignContent={"center"}>
          <div style={{ justifyContent: "center", alignContent: "center", display: "flex" }}>
            <BarChart width={250} height={140} data={dataChartBar.current} margin={{}}>
              <XAxis dataKey="name" height={20} fontSize={10} />
              <YAxis domain={[0, 0]} dataKey="value" width={20} fontSize={10} />
              <Bar dataKey="value" fill={COLORS[0]} />
            </BarChart>
          </div>
        </Grid>
      </Grid>
    );
  }

  if (isLoading) {
    return <LoadingComponent />;
  }
  const displayAbsence = requests ? (
    requests.map((dataObject, count) => {
      if (dataObject.filter !== "" && historie === true) return undefined;
      const text = dataObject.title;
      const startorig = dataObject.start_orig;
      const endorig = dataObject.end_orig;
      const state = dataObject.state;
      const btn = () => {
        if (dataObject.kenntnis !== "J")
          return (
            <IconButton
              variant="contained"
              color="primary"
              onClick={() => {
                handleAbsenceActionClick(count);
              }}
            >
              <EditIcon />
            </IconButton>
          );
        if (dataObject.kenntnis === "J")
          return (
            <IconButton
              variant="contained"
              color="primary"
              onClick={() => {
                handleAbsenceActionClick(count);
              }}
            >
              <VisibilityIcon />
            </IconButton>
          );
      };
      return (
        <TableRow key={count}>
          <TableCell>
            {admin !== "J" && dataObject.kenntnis === "J" ? (
              <Badge
                color="info"
                badgeContent="neu"
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <Box>
                  {text}
                  <br />
                  {startorig + " - " + endorig}
                </Box>
              </Badge>
            ) : (
              <Box>
                {text}
                <br />
                {startorig + " - " + endorig}
              </Box>
            )}
          </TableCell>
          <TableCell>
            <Typography variant="body2">{state}</Typography>
          </TableCell>
          <TableCell align="right">{btn()}</TableCell>
        </TableRow>
      );
    })
  ) : (
    <TableRow key="-">
      <TableCell component="th" scope="row">
        -
      </TableCell>
      <TableCell align="right">-</TableCell>
      <TableCell align="right">-</TableCell>
      <Hidden xlDown>
        <TableCell align="right">-</TableCell>
      </Hidden>
      <TableCell align="right">-</TableCell>
    </TableRow>
  );
  // <div className="container-fluid h-100 p-2 ectool-scroll">
  function Abbrechen() {
    setOpenUrlaub("");
    setOpenGleitzeit("");
    setOpenKranktage("");
  }
  function OpenRD(item, count) {
    if (item.typ === "1") {
      setOpenUrlaub(item);
    }
    if (item.typ === "2") {
      setOpenGleitzeit(item);
    }
    if (item.typ === "3") {
      setOpenKranktage(item);
    }
  }

  const renderRestUrlaubsAnzeige = () => {
    const currentFehlzeit = fehlzeiten[fehlzeitenIndex];
    const zszdKey = currentFehlzeit?.zszdKey;
    const shouldRender = zszdKey === "URL " && showBeantragteBeiAntrag;

    const saldo = shouldRender ? salden?.find((s) => s.key === zszdKey) : null;
    const restZum3112 = saldo?.final ?? "0.00";
    const beantragt = saldo?.beantragt ?? "0";

    if (shouldRender)
      return (
        <>
          <Grid item xs={12} md={6}>
            <TextField disabled fullWidth label={t("Rest zum 31.12")} value={restZum3112} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField disabled fullWidth label="...davon bereits beantragt (noch zur Bearbeitung beim Vorgesetzten)" value={beantragt} />
          </Grid>
        </>
      );
  };

  const Zeichnen = () => {
    return (
      <Fragment>
        <ResponsiveDialog
          title={t("Urlaubsstatistik") + " " + jahr + " (" + openUrlaub.text + ")"}
          maxWidth="sm"
          open={openUrlaub}
          setOpen={(o) => setOpenUrlaub("")}
          actionButton={
            <Button color="primary" onClick={() => Abbrechen()}>
              {t("Zurück")}
            </Button>
          }
        >
          <DialogContent>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell pl={5}>{t("Rest Vorjahr (" + (jahr - 1).toString() + ")")}</TableCell>
                    <TableCell align="right">{openUrlaub && openUrlaub.remains}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Jahresurlaub (" + jahr.toString() + ")")}</TableCell>
                    <TableCell align="right">{openUrlaub && openUrlaub.year}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Typography fontWeight={900}>{t("Gesamtanspruch")}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography fontWeight={900}>{openUrlaub && openUrlaub.gesamtanspruch}</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Verbrauch bis heute")}</TableCell>
                    <TableCell align="right">{openUrlaub && (today.substr(0, 4) <= jahr ? openUrlaub.genommen_bis_heute : openUrlaub.taken)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Typography fontWeight={900}>{t("Endstand heute")}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography fontWeight={900}>{openUrlaub && (today.substr(0, 4) <= jahr ? openUrlaub.current : openUrlaub.final)}</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("geplant und genehmigt")}</TableCell>
                    <TableCell align="right">{openUrlaub && (today.substr(0, 4) <= jahr ? openUrlaub.planed_gen : "0.00")}</TableCell>
                  </TableRow>
                  {/* {parseFloat(openUrlaub?.betriebsferien) > 0 && (
                    <TableRow>
                      <TableCell>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                          <Typography variant="body2">{t(" > davon Betriebsferien")}</Typography>
                          {(openUrlaub?.betriebsferienInfo || "")
                            .split("#")
                            .filter(Boolean)
                            .map((text, index) => (
                              <Typography key={index} variant="caption" color="text.secondary">
                                {text}
                              </Typography>
                            ))}
                        </Box>
                      </TableCell>
                      <TableCell align="right">{today.substr(0, 4) <= jahr ? openUrlaub.betriebsferien : "0.00"}</TableCell>
                    </TableRow>
                  )} */}
                  {parseFloat(openUrlaub?.betriebsferien) > 0 && (
                    <TableRow sx={{ verticalAlign: "top" }}>
                      <TableCell sx={{ py: 1.5, px: 2 }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                          {/* 1. Header (no value on right) */}
                          <Typography variant="body2" fontWeight="500">
                            {t(" > davon Betriebsferien")}
                          </Typography>

                          {/* 2. Detail lines */}
                          {(openUrlaub?.betriebsferienInfo || "")
                            .split("#")
                            .filter(Boolean)
                            .map((text, i) => {
                              const cleanText = text.replace(/\s*\(\d+\.?\d*\s*Arbeitstage?\)/, "").trim();
                              return (
                                <Typography key={i} variant="caption" color="text.secondary" sx={{ lineHeight: 1.5 }}>
                                  {cleanText}
                                </Typography>
                              );
                            })}

                          {/* <Typography variant="body2" fontWeight="500" sx={{ mt: 0.5 }}>
                            Summe
                          </Typography> */}
                        </Box>
                      </TableCell>

                      <TableCell align="right" sx={{ py: 1.5, px: 2 }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                          {/* Spacer to align with header */}
                          <Box sx={{ height: "1.43em" }} />

                          {/* Detail values */}
                          {(openUrlaub?.betriebsferienInfo || "")
                            .split("#")
                            .filter(Boolean)
                            .map((text, i) => {
                              const match = text.match(/\((\d+\.?\d*)\s*Arbeitstage?\)/);
                              return (
                                <Typography key={i} variant="caption" color="text.secondary" sx={{ lineHeight: 1.5 }}>
                                  {match ? match[1] : "0.00"}
                                </Typography>
                              );
                            })}

                          {/* Summary value */}
                          <Typography variant="body2" fontWeight="500" sx={{ mt: 0.5 }}>
                            {today.substr(0, 4) <= jahr ? openUrlaub.betriebsferien : "0.00"}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}

                  <TableRow>
                    <TableCell>
                      <Typography fontWeight={900}>{t("Verbrauch Gesamt")}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography fontWeight={900}>{openUrlaub && openUrlaub.taken}</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("> davon Genommen")}</TableCell>
                    <TableCell align="right">{openUrlaub && openUrlaub.genommen}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("> davon Korrekturen")}</TableCell>
                    <TableCell align="right">{openUrlaub && openUrlaub.korrektur}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("> davon Auszahlungen")}</TableCell>
                    <TableCell align="right">{openUrlaub && openUrlaub.ausgezahlt}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("> " + openUrlaub.verfallen_text)}</TableCell>
                    <TableCell align="right">{openUrlaub && openUrlaub.verfallen}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Typography fontWeight={900}>{t("Endstand (" + jahr.toString() + ")")}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography fontWeight={900}>{openUrlaub && openUrlaub.final}</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Beantragt (noch nicht genehmigt)")}</TableCell>
                    <TableCell align="right">{openUrlaub && openUrlaub.beantragt}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </ResponsiveDialog>
        <ResponsiveDialog
          title={t("Gleitzeitstatistik") + " " + jahr + " (" + openGleitzeit.text + ")"}
          maxWidth="sm"
          open={openGleitzeit}
          setOpen={(o) => setOpenGleitzeit("")}
          actionButton={
            <Button color="primary" onClick={() => Abbrechen()}>
              {t("Zurück")}
            </Button>
          }
        >
          <DialogContent>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>{t("Monat")}</TableCell>
                    <TableCell align="right">{t("laufend")}</TableCell>
                    <TableCell align="right">{t("Endstand")}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Übertrag")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.ueb}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.ueb}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Januar")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m1}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m1ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Februar")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m2}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m2ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("März")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m3}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m3ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("April")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m4}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m4ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Mai")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m5}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m5ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Juni")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m6}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m6ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Juli")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m7}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m7ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("August")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m8}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m8ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("September")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m9}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m9ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Oktober")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m10}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m10ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("November")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m11}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m11ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Dezember")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m12}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.m12ges}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Gesamt")}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.summe}</TableCell>
                    <TableCell align="right">{openGleitzeit && openGleitzeit.summe}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </ResponsiveDialog>
        <ResponsiveDialog
          title={t("Krankheitsstatistik") + " " + jahr}
          open={openKranktage}
          maxWidth="sm"
          setOpen={(o) => setOpenKranktage("")}
          actionButton={
            <Button color="primary" onClick={() => Abbrechen()}>
              {t("Zurück")}
            </Button>
          }
        >
          <DialogContent>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>{t("Januar")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m1}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Februar")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m2}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("März")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m3}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("April")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m4}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Mai")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m5}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Juni")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m6}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Juli")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m7}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("August")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m8}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("September")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m9}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Oktober")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m10}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("November")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m11}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Dezember")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.m12}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("Gesamt")}</TableCell>
                    <TableCell align="right">{openKranktage && openKranktage.summe}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </ResponsiveDialog>
        <Page>
          <Layout fullWidth>
            <Box pt={3} pb={1}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setActive(null);
                  fehlzeiten && fehlzeiten.length > 0 ? setOpen(true) : setErrFz(true);
                }}
              >
                <Typography style={{ fontSize: "15", fontWeight: "700" }}>{t("Neue Abwesenheit")}</Typography>
              </Button>
            </Box>
          </Layout>
          <Layout>
            <Grid container>
              <Grid item>
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <Tabs
                    size="small"
                    variant="scrollable"
                    value={ansicht}
                    scrollButtons
                    onChange={(e, value) => {
                      setAnsicht(value);
                      localStorage.setItem("ansicht", value.toString());
                    }}
                    aria-label="Vertical tabs example"
                  >
                    <Tab label={t("Anträge")} />
                    <Tab label={t("Kalender")} />
                    <Tab label={t("Stand")} />
                  </Tabs>
                </Box>
              </Grid>
            </Grid>
          </Layout>
          {ansicht === 2 && (
            <Fragment>
              <Layout>
                <Grid container>
                  <Grid item xs={12}>
                    <Box pt={1} pr={1} pl={1}>
                      <Toolbar>
                        <PreviousYearButton onClick={() => jahresWechsel(jahr - 1)} />
                        <Box style={{ flexGrow: 1 }}></Box>
                        <Box pt={1.3}>
                          <Typography>{t("Jahr") + " " + jahr}</Typography>
                        </Box>
                        <Box style={{ flexGrow: 1 }}></Box>
                        <NextYearButton onClick={() => jahresWechsel(jahr + 1)} />
                      </Toolbar>
                    </Box>
                  </Grid>
                  {/* <Grid item xs={12}>
                    <Box>
                      <Typography color="error" align="center" variant="caption">
                        {t("- Für Details bitte auf das gewünschte Konto klicken -")}
                      </Typography>
                    </Box>
                  </Grid> */}
                </Grid>
              </Layout>
              <Grid container justifyContent={"center"}>
                <Grid item xs={12} md={8}>
                  {Kontenstaende()}
                </Grid>
              </Grid>
            </Fragment>
          )}
          {ansicht === 0 && (
            <Fragment>
              <Layout>
                <Box padding={2}>
                  <FormControlLabel
                    control={
                      <RB
                        checked={historie}
                        onChange={(event) => setHistorie(event.target.checked)}
                        name="Historie"
                        color="primary"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    }
                    label={t("Nur aktuelle Anträge anzeigen")}
                  />
                  <TableContainer>
                    <Table>
                      <TableBody>{displayAbsence}</TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Layout>
            </Fragment>
          )}
          {ansicht === 1 && !isSending && (
            <Fragment>
              <Layout>
                <Grid container>
                  <Grid item xs={12}>
                    <Box p={1}>
                      <Toolbar>
                        <PreviousYearButton onClick={() => jahresWechsel(jahr - 1)} />
                        {!jahresAnsicht && <PreviousMonthButton onClick={() => monatsWechsel(false)} />}

                        <Box style={{ flexGrow: 1 }}></Box>
                        <Box pt={1.3}>
                          <Typography>{jahresAnsicht ? t("Jahr") + " " + jahr : t(getMonthName(monat)) + " " + jahr}</Typography>
                        </Box>
                        <Box style={{ flexGrow: 1 }}></Box>
                        {!jahresAnsicht && <NextMonthButton onClick={() => monatsWechsel(true)} />}
                        <NextYearButton onClick={() => jahresWechsel(jahr + 1)} />
                      </Toolbar>
                    </Box>
                  </Grid>
                </Grid>

                <Fehlzeitenkalender
                  client={client}
                  accessToken={accessToken}
                  onlineid={onlineid}
                  key={keynumber}
                  jahresAnsicht={jahresAnsicht}
                  onJahresAnsichtChange={handleAnsichtChange}
                  uebevents={events}
                  uebsondertage={sondertage}
                  ueblegende={legende}
                  year={jahr}
                  setYear={jahresWechsel}
                  month={monat}
                  setMonth={setMonat}
                  noYearRefresh
                />
              </Layout>
            </Fragment>
          )}
          {ansicht === 3 && (
            <Layout>
              <Fehlzeitenkalender
                client={client}
                accessToken={accessToken}
                onlineid={onlineid}
                key={keynumber}
                jahresAnsicht={true}
                nurkonten={true}
                year={jahr}
                setYear={jahresWechsel}
                month={monat}
                setMonth={setMonat}
              />
            </Layout>
          )}
          <ResponsiveDialog
            title={fehlzeiten.length > 0 ? (active !== null ? "Abwesenheit bearbeiten" : "Neue Abwesenheit") : ""}
            open={open}
            setOpen={(o) => setOpen(o)}
            actionButton={
              <>
                <Box pl={1}>
                  <Button
                    color="primary"
                    endIcon={<SendIcon />}
                    disabled={startDateError || endDateError || startZeitError || endZeitError}
                    variant="contained"
                    onClick={() => {
                      if (fehlzeitenIndex !== -1) {
                        handleNewAbsenceClick(
                          0,
                          sperre && fehlzeiten && fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && sperre["f" + fehlzeiten[fehlzeitenIndex].key]
                            ? sperre["f" + fehlzeiten[fehlzeitenIndex].key]
                            : "",
                        );
                      } else {
                        setFehlzeitenIndexError(true);
                      }
                    }}
                  >
                    {t("senden")}
                  </Button>
                </Box>
                <Box pl={1}>
                  <Button color="primary" endIcon={<CancelIcon />} variant="text" onClick={() => ResetData()}>
                    {t("Abbrechen")}
                  </Button>
                </Box>
                {dateList && dateList.length > 0 && zeiten && zeiten.length > 0 && (
                  <Box pl={1}>
                    <Button color="secondary" variant="text" onClick={() => handleNewAbsenceClick(7, "")}>
                      {t("Vormerken")}
                    </Button>
                  </Box>
                )}
                {active !== null && (
                  <Box pl={1}>
                    <Button endIcon={<DeleteIcon />} variant="text" color="secondary" onClick={() => Delete(active)}>
                      {t("Antrag Löschen")}
                    </Button>
                  </Box>
                )}
              </>
            }
          >
            <Box p={2}>
              <form>
                <Grid container spacing={2}>
                  {requestDate && (
                    <Grid item xs={12}>
                      <Alert severity="info">{t("Abwesenheit beantragt am") + " " + requestDate}</Alert>
                    </Grid>
                  )}
                  <Grid item xs={12} md={12}>
                    <TextField
                      id="typeOfAbsence"
                      label={t("Art")}
                      select
                      fullWidth
                      value={fehlzeitenIndex}
                      error={fehlzeitenIndexError}
                      onChange={(e) => {
                        setFehlzeitenIndexError(false);
                        setFehlzeitenIndex(e.target.value);
                        setZeiten([]);
                        setProz("");
                        ChangeReisegrund(e.target.value);
                      }}
                      variant="outlined"
                      disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                    >
                      {fehlzeiten.map((fz, index) => (
                        <MenuItem key={index} value={index}>
                          {fz.bez}
                        </MenuItem>
                      ))}
                    </TextField>
                    {/* {salden.find((s)=>s.key===fehlzeiten[fehlzeitenIndex]?.zszdKey)?.beantragt &&<>
                      <Typography variant="secondary">Rest zum Jahresende: {salden.find((s)=>s.key===fehlzeiten[fehlzeitenIndex]?.zszdKey)?.final}</Typography>
                      <Typography variant="secondary">Bereits beantragt: {salden.find((s)=>s.key===fehlzeiten[fehlzeitenIndex]?.zszdKey)?.beantragt}</Typography></>
                    } */}
                  </Grid>
                  {renderRestUrlaubsAnzeige()}
                  {sdatei && sdatei === "1" && fehlzeitenIndex && fehlzeitenIndex >= 0 && fehlzeiten[fehlzeitenIndex].key === "004" && (
                    <Fragment>
                      <Grid item xs={12}>
                        <Button variant="outlined" fullWidth color="primary" onClick={() => Sonderurlaub()}>
                          {"Richtlinien " + fehlzeiten[fehlzeitenIndex].bez + " anzeigen (PDF)"}
                        </Button>
                      </Grid>
                    </Fragment>
                  )}
                  {wdatei && wdatei === "1" && fehlzeitenIndex && fehlzeitenIndex >= 0 && fehlzeiten[fehlzeitenIndex].key === "080" && (
                    <Fragment>
                      <Grid item xs={12}>
                        <Button variant="outlined" fullWidth color="primary" onClick={() => Wertguthaben()}>
                          {"Richtlinien " + fehlzeiten[fehlzeitenIndex].bez + " anzeigen (PDF)"}
                        </Button>
                      </Grid>
                    </Fragment>
                  )}
                  <Grid item xs={12}>
                    <DateTextField
                      id="startDate"
                      label={t("Von Datum")}
                      fullWidth
                      error={startDateError}
                      helperText={startDateError}
                      onChange={(e) => setStartDate(e.target.value)}
                      value={startDate}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  {fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].uhrzeit === "1" && (
                    <Grid item xs={12}>
                      <TextField
                        id="startTime"
                        label={t("Von Zeit")}
                        type="time"
                        error={startZeitError}
                        helperText={startZeitError}
                        fullWidth
                        disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                        onChange={(e) => setStartTime(e.target.value)}
                        value={startTime}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <DateTextField
                      id="endDate"
                      label={t("Bis Datum")}
                      fullWidth
                      error={endDateError}
                      helperText={endDateError}
                      onChange={(e) => setEndDate(e.target.value)}
                      //onBlur={checkDates}
                      value={endDate}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>

                  {fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].uhrzeit === "1" && (
                    <Grid item xs={12}>
                      <TextField
                        id="endTime"
                        label={t("Bis Zeit")}
                        type="time"
                        error={endZeitError}
                        helperText={endZeitError}
                        fullWidth
                        disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                        //error={startDateError}
                        //helperText={startDateError}
                        onChange={(e) => setEndTime(e.target.value)}
                        value={endTime}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  )}
                  {fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].dauer === "1" && (
                    <Grid item xs={12}>
                      <TextField
                        id="duration"
                        label={t("Dauer")}
                        type="time"
                        fullWidth
                        disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                        onChange={(e) => setDauer(e.target.value)}
                        value={dauer}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  )}
                  {fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].proz && fehlzeiten[fehlzeitenIndex].proz.length > 0 && (
                    <Grid item xs={12}>
                      <TextField
                        id="proz"
                        label={t("Auszahlungsprozent")}
                        select
                        fullWidth
                        disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                        value={proz}
                        onChange={(e) => setProz(e.target.value)}
                        variant="outlined"
                      >
                        {fehlzeiten[fehlzeitenIndex].proz.map((item, index) => (
                          <MenuItem key={index} value={item.wert}>
                            {item.wert}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  )}
                  {fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].min && fehlzeiten[fehlzeitenIndex].max > 0 && (
                    <Grid item xs={12}>
                      <TextField
                        id="proz"
                        label={t("Auszahlungsprozent")}
                        fullWidth
                        disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                        value={proz}
                        onChange={(e) => ValidateSetProz(e.target.value)}
                        variant="outlined"
                      />
                    </Grid>
                  )}
                  {fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].vertreter === "1" && (
                    <Grid item xs={12}>
                      <TextField
                        id="vertreter"
                        label={t("Vertreter")}
                        select
                        type="number"
                        fullWidth
                        disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                        value={vertreter}
                        onChange={(e) => setVertreter(e.target.value)}
                        variant="outlined"
                      >
                        {vertreterList.length > 0 &&
                          vertreterList.map((vert, index) => (
                            <MenuItem key={index} value={index}>
                              {vert.name}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                  )}
                  {fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].an_hinweis !== "" && (
                    <Grid item xs={12}>
                      <TextField
                        id="anHinweis"
                        label={t("Hinweis vom Arbeitgeber")}
                        type="text"
                        fullWidth
                        multiline
                        focused
                        rows={3}
                        color="primary"
                        value={fehlzeiten[fehlzeitenIndex].an_hinweis}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ disabled: true }}
                      />
                    </Grid>
                  )}
                  {fehlzeiten.length > 0 &&
                    fehlzeiten[fehlzeitenIndex] &&
                    (fehlzeiten[fehlzeitenIndex].bemerkung === "1" || fehlzeiten[fehlzeitenIndex].vertreter === "1") && (
                      <Grid item xs={12}>
                        <DateTextField
                          id="comment"
                          label={t("Bemerkung/Grund")}
                          multiline
                          fullWidth
                          disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                          rows={3}
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                          variant="outlined"
                        />
                      </Grid>
                    )}
                  {fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].fahrzeit === "1" && (
                    <Grid item xs={12}>
                      <TextField
                        id="fahrzeit"
                        label={t("Fahrtzeit gesamt")}
                        type="time"
                        fullWidth
                        disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                        value={fahrzeit}
                        onChange={(e) => setFahrzeit(e.target.value)}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  )}
                  {fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].reise === "1" && (
                    <Fragment>
                      <Grid item xs={12}>
                        <TextField
                          id="travelReason"
                          label={t("Reisegrund")}
                          select
                          fullWidth
                          disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                          value={travelReason}
                          onChange={(e) => setTravelReason(e.target.value)}
                          variant="outlined"
                        >
                          {reiseauswahl.length > 0 &&
                            reiseauswahl.map((reise, index) => (
                              <MenuItem key={index} value={index}>
                                {reise.bez}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                      {reisedest && reisedest === "1" && (
                        <Grid item xs={12}>
                          <TextField
                            id="travelLocation"
                            label={t("Reiseland")}
                            fullWidth
                            select={reiseland.length > 0 ? true : false}
                            disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                            value={travelLocation}
                            onChange={(e) => setTravelLocation(e.target.value)}
                            variant="outlined"
                          >
                            {reiseland.length > 0 &&
                              reiseland.map((reise, index) => (
                                <MenuItem key={index} value={index}>
                                  {reise.bez}
                                </MenuItem>
                              ))}
                          </TextField>
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        <TextField
                          id="travelLoc"
                          label={t("Reiseort")}
                          fullWidth
                          disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                          value={travelloc}
                          onChange={(e) => setTravelloc(e.target.value)}
                          variant="outlined"
                        ></TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="travelVehicle"
                          label={t("Verkehrsmittel")}
                          select
                          fullWidth
                          value={travelVehicle}
                          onChange={(e) => setTravelVehicle(e.target.value)}
                          variant="outlined"
                          disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                        >
                          {reisevkm.length > 0 &&
                            reisevkm.map((reise, index) => (
                              <MenuItem key={index} value={index}>
                                {reise.bez}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    </Fragment>
                  )}
                  {fehlzeiten.length > 0 &&
                    fehlzeiten[fehlzeitenIndex] &&
                    fehlzeiten[fehlzeitenIndex].zusatz_zeiten &&
                    zeiten &&
                    dateList &&
                    dateList.length > 0 &&
                    zeiten.map((zeit, index) => (
                      <Fragment>
                        <Grid item xs={12}>
                          <hr align="center" width="100%" />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography align="left">{t("Arbeitszeit angeben")}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            id={"datum" + index}
                            label={t("Datum")}
                            select
                            fullWidth
                            disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                            value={zeit.datum}
                            onChange={(e) => {
                              zeit.datum = e.target.value;
                              setZeiten([...zeiten]);
                            }}
                            variant="outlined"
                          >
                            {dateList.map((date, index) => (
                              <MenuItem key={index} value={date}>
                                {date}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        {fehlzeiten.length > 0 &&
                          fehlzeiten[fehlzeitenIndex] &&
                          fehlzeiten[fehlzeitenIndex].ZEITART &&
                          fehlzeiten[fehlzeitenIndex].ZEITART.length > 1 && (
                            <Grid item xs={12}>
                              <TextField
                                id={"zeitart" + index}
                                label={t("Zeitart")}
                                select
                                type="number"
                                fullWidth
                                disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                                value={zeit.za_key}
                                onChange={(e) => {
                                  zeit.za_key = e.target.value;
                                  setZeiten([...zeiten]);
                                }}
                                variant="outlined"
                              >
                                {fehlzeiten[fehlzeitenIndex].ZEITART.map((zeita, index) => (
                                  <MenuItem key={zeita.KEY} value={zeita.KEY}>
                                    {zeita.BEZ}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                          )}
                        <Grid item xs={12}>
                          <TextField
                            id={"von" + index}
                            label={t("Von Zeit")}
                            type="time"
                            fullWidth
                            disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                            onChange={(e) => {
                              zeit.vzeit = e.target.value;
                              setZeiten([...zeiten]);
                            }}
                            value={zeit.vzeit}
                            variant="outlined"
                            ä
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            id={"bis" + index}
                            label={t("Bis Zeit")}
                            type="time"
                            fullWidth
                            disabled={active !== null && requests[active].status !== "0" && requests[active].status !== "7" ? true : false}
                            onChange={(e) => {
                              zeit.bzeit = e.target.value;
                              setZeiten([...zeiten]);
                            }}
                            value={zeit.bzeit}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Button variant="contained" color="primary" onClick={() => ChangeZeiten("", "del", index)}>
                            {t("Arbeitszeit entfernen")}
                          </Button>
                        </Grid>
                      </Fragment>
                    ))}
                  {dateList && dateList.length > 0 && fehlzeiten.length > 0 && fehlzeiten[fehlzeitenIndex] && fehlzeiten[fehlzeitenIndex].zusatz_zeiten && (
                    <Fragment>
                      <Grid item xs={12}>
                        <Button variant="contained" color="primary" onClick={() => NewLine()}>
                          {t("Arbeitszeit hinzufügen")}
                        </Button>
                      </Grid>
                    </Fragment>
                  )}
                  {(dateList &&
                    dateList.length > 0 &&
                    fehlzeiten.length > 0 &&
                    fehlzeiten[fehlzeitenIndex] &&
                    fehlzeiten[fehlzeitenIndex].zkor &&
                    fehlzeiten[fehlzeitenIndex].zkor.length > 0 &&
                    zeiten &&
                    zeiten.length) > 0 && (
                    <Fragment>
                      <Grid item xs={12}>
                        <TextField
                          id="Vergütungsart"
                          label={t("Vergütungsart")}
                          select
                          fullWidth
                          disabled={
                            (active !== null && requests[active].status !== "0" && requests[active].status !== "7") ||
                            fehlzeiten[fehlzeitenIndex].zkor.length === 1
                              ? true
                              : false
                          }
                          value={zahlart}
                          onChange={(e) => setZahlart(e.target.value)}
                          variant="outlined"
                        >
                          {fehlzeiten[fehlzeitenIndex].zkor &&
                            fehlzeiten[fehlzeitenIndex].zkor.length > 0 &&
                            fehlzeiten[fehlzeitenIndex].zkor.map((item, index) => (
                              <MenuItem key={index} value={index}>
                                {item.bez}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    </Fragment>
                  )}
                </Grid>
              </form>
            </Box>
          </ResponsiveDialog>
          {(isSending || showModal) && <FullPageSpinner />}
          <MessageBox
            title={t("Hinweis")}
            text={t("Der Kontostand fällt mit dem Antrag unter " + grenze.current.toString() + ", trotzdem beantragen?")}
            buttons="YESNO"
            onClose={closeMessageBox}
            open={messageBoxOpen}
            handleResponse={messageBoxResult}
          />
          <MessageBox
            title={t("Hinweis Abwesenheiten")}
            text={t("Aktuell stehen noch keine Abwesenheiten zur Auswahl. Bitte wenden Sie sich für weitere Informationen an Ihre Personalabteilung.")}
            buttons="OK"
            onClose={() => setErrFz(false)}
            open={errFz}
            handleResponse={(r) => setErrFz(false)}
          />
          <ElevationScroll {...props}>
            <Fab
              color="primary"
              aria-label="add"
              style={{ position: "fixed", bottom: 20, right: 20 }}
              onClick={() => {
                setActive(null);
                fehlzeiten && fehlzeiten.length > 0 ? setOpen(true) : setErrFz(true);
              }}
            >
              <AddIcon />
            </Fab>
          </ElevationScroll>
        </Page>
      </Fragment>
    );
  };
  return (
    <Routes>
      <Route path="/" element={Zeichnen()} />
    </Routes>
  );
}
export default Absence;
